<div class="productDetailsSuccess">
    <div  class="productDetailsSuccess__top">
        <div class="productDetailsSuccess__product">
            <h4>{{ 'productDetails.success.added' | translate }}</h4>
            <figure>
                <img
                    [ngSrc]="picture"
                    width="100%"
                    height=""
                    [alt]="product.name"
                />
            </figure>
            <dl class="productDetailsSuccess__product__info">
                <dt>{{ 'productDetails.success.model' | translate }}</dt>
                <dd>{{ product.brandName }}, {{ product.name }}</dd>
                <dt>
                    {{ 'productDetails.success.price.glasses' | translate }}
                </dt>
                <dd>{{ priceInformations.discountPrice ? priceInformations.discountPrice.formattedValue : priceInformations.price.formattedValue }}</dd>
                <dd *ngIf="priceInformations.discountPrice" class="productDetailsSuccess__product__info--catalog">{{ priceInformations.price.formattedValue  }}</dd>
            
            </dl>
        </div>
        <div class="productDetailsSuccess__insurance" *ngIf="insurance">
            <h4>{{ insurance.title }}</h4>
            <ul *ngIf="insurance.benefits">
                <li *ngFor="let element of insurance.benefits">
                    {{ element }}
                </li>
            </ul>
            <div [innerHTML]="insurance.content"></div>
            <p class="productDetailsSuccess__insurance__price">
                <b>{{
                    'productDetails.success.price.insurance' | translate
                }}</b>
                {{ product.insurancePrice.formattedValue }}
            </p>
            <button
                class="productDetailsSuccess__insurance__button"
                (click)="confirmInsurance()"
            >
                {{ 'productDetails.success.button.insurance' | translate }}
            </button>
            <a [href]="insurance.linkUrl" target="_blank">{{
                insurance.linkName
            }}</a>
        </div>
    </div>
    <div class="productDetailsSuccess__nav">
        <button [disabled]="submitted" (click)="backToDetails()">
            {{ 'productDetails.success.nav.shopping' | translate }}
        </button>
        <a href="/cart">{{ 'productDetails.success.nav.cart' | translate }}</a>
    </div>
</div>
